import React from 'react';
import * as css from './SmsScreen.css';
import {updateDesignEmail} from '../../../redux/branding/brandingActions';
import SmsEditor from '../smsEditor/SmsEditor';
import {useEffect} from 'react';
import {useContext} from 'react';
import {BrandingContext} from '../context/BrandingContext';
import AccountPermission from '../../components/accountPermission/AccountPermission';
import {useSelector} from 'react-redux';
import {useBrandingParams} from '../../../hooks/useBrandingParams';

function SmsScreen() {
    const {textEditor: {setCurrentEditorName}} = useContext(BrandingContext);
    const eventType=useSelector(s=>s.event.type);
    const {messageType} = useBrandingParams();
    useEffect(() => {
        setCurrentEditorName('smsContent');
    }, []);

    const shouldShowSmsEnter = !['course', 'givechak', 'subscription'].includes(eventType) && messageType==='sendTicket';

    return (
        <css.wrapper data-cy='smsScreen'>
            <SmsEditor name={'smsContent'} onSave={(content)=>updateDesignEmail(messageType, {smsContent:content, content, mailingType: 'sms'})}/>
            {shouldShowSmsEnter && <AccountPermission permission={'sms enter'}>
                <SmsEditor name={'smsEnterContent'} onSave={(content)=>updateDesignEmail(messageType, {smsEnterContent:content, content, mailingType: 'sms'})}/>
            </AccountPermission>}
            {eventType === 'givechak' && messageType === 'sendTicket' && (
                <SmsEditor
                    name="smsRefContent"
                    onSave={(content) => updateDesignEmail(messageType, {smsRefContent: content, content, mailingType: 'sms'})}
                />
            )}
        </css.wrapper>
    );
}

export default SmsScreen;